import { Alert } from '../Alert';
import { Spacer } from '../Layout';
import { Text } from '../Text';

type ErrorAlertProps = {
  text: string;
  /** Sets a top margin or a bottom margin, depending on what is chosen */
  marginDirection?: 'top' | 'bottom';
  hasIcon?: boolean;
};

/** @deprecated Use Feedback component */
export const ErrorAlert = ({ text, marginDirection = 'top', hasIcon = true }: ErrorAlertProps) => (
  <Spacer
    marginTop={marginDirection === 'top' ? [30, 30, 20] : 0}
    marginBottom={marginDirection === 'bottom' ? [30, 30, 20] : 0}
  >
    <Alert variant="danger" wrap={false} hasIcon={hasIcon}>
      <Text>{text}</Text>
    </Alert>
  </Spacer>
);
